export default "__VITE_ASSET__BZg_42HK__"